import { useWindowDimensions } from "../WindowDimensions";
import { GalleryImg } from '../Data'
import "./../style/Gallery.css";
import "./../style/Global.css";

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

 const Gallery = () => {
  const { width } = useWindowDimensions();
  return (
    <div className="gallery" id="Gallery">
      {width > 768 ? (
        <>
          <h1 className="gallery-title">Наши работы</h1>
          <div className="gallery-container">
            {GalleryImg.map((gallery, key) => {
              return (
                <div
                  className="gallery-item"
                  key={key}
                >
                  <img
                    className="galary-img"
                    src={gallery.galeryImg}
                    alt=""
                  />
                </div> 
              )
            })}
          </div> 
        </> 
      ) : (
        <>
          <h1 className="gallery-title">Наши работы</h1>
          <Swiper
           modules={[Navigation, Pagination]}
           navigation
           pagination={{ clickable: 'true' }}
          >
            {GalleryImg.map((gallery, key) => {
              return (
                <SwiperSlide key={key}>
                  <img
                    className="swiper-gallery"
                    src={gallery.galeryImg}
                    alt=""
                  />
                </SwiperSlide>
              )
            })}
          </Swiper>
        </>
      )
      }
    </div>
  )
}
export default Gallery